"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAccessDataFromValidatorQrCode = extractAccessDataFromValidatorQrCode;
function extractAccessDataFromValidatorQrCode(qrCodeContent) {
    var _a, _b;
    const accessCodeRegex = /.*validator\/(.*)/;
    const qrPayload = JSON.parse(qrCodeContent);
    const baseUrl = new URL(qrPayload.url).origin;
    const accessToken = (_b = (_a = qrPayload.url) === null || _a === void 0 ? void 0 : _a.match(accessCodeRegex)) === null || _b === void 0 ? void 0 : _b[1];
    return {
        baseUrl,
        accessToken,
    };
}
//# sourceMappingURL=validator.js.map